import { render, staticRenderFns } from "./diseaseType.vue?vue&type=template&id=38d10d6c"
import script from "./diseaseType.vue?vue&type=script&lang=js"
export * from "./diseaseType.vue?vue&type=script&lang=js"
import style0 from "./diseaseType.vue?vue&type=style&index=0&id=38d10d6c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports